import React, { Component } from 'react';

import AsideView from '@uicomponents/AsideView';
import Loader from '@uicomponents/Loader';

import ChauffeurForm from './ChauffeurForm';

export default class UpdateChauffeurPage extends Component {
  render() {
    const { t, formChauffeur, isFetchingChauffeur, updateChauffeur } =
      this.props;

    if (!formChauffeur || isFetchingChauffeur) {
      return (
        <div className="absolute-center">
          <Loader />
        </div>
      );
    }

    return (
      <AsideView>
        <h1>{t('chauffeur.update')}</h1>
        <ChauffeurForm
          {...this.props}
          key={formChauffeur.id}
          onSubmit={(chauffeur) => updateChauffeur(chauffeur)}
        />
      </AsideView>
    );
  }
}
